// import emHome from "@/views/em/Home";

import sithMesRoutersMst from "@/router/sithMes/mst/moduleIndex-router-sithMes-mst";
import sithMesRoutersMstManural from "@/router/sithMes/mst/moduleIndex-router-sithMes-mst-manural";
import sithMesRoutersAndon from "@/router/sithMes/andon/moduleIndex-router-sithMes-andon";
import sithMesRoutersPrd from "@/router/sithMes/prd/moduleIndex-router-sithMes-prd";
import sithMesRoutersPrdCustom from "@/router/sithMes/prd/moduleIndex-router-sithMes-prd-custom";
import sithMesRoutersQuality from "@/router/sithMes/quality/moduleIndex-router-sithMes-quality";
import sithMesRoutersInventory from "@/router/sithMes/inventory/moduleIndex-router-sithMes-inventory";
import sithMesRoutersStool from "@/router/sithMes/stool/moduleIndex-router-sithMes-stool";
import sithMesRoutersInventoryCustom from "@/router/sithMes/inventory/moduleIndex-router-sithMes-inventory-custom";
import sithMesRoutersRita from "@/router/sithMes/rita/moduleIndex-router-sithMes-rita";
import sithMesRoutersTpm from "@/router/sithMes/tpm/moduleIndex-router-sithMes-tpm";
import sithMesRoutersCustomer from "@/router/sithMes/customer/moduleIndex-router-sithMes-customer";
import sithMesRoutersAgreement from "@/router/sithMes/agreement/moduleIndex-router-sithMes-agreement";
import sithMesRoutersAgreementCustom from "@/router/sithMes/agreement/moduleIndex-router-sithMes-agreement-custom";


export default [
    // {path: "/em", name: "emHome", component: emHome},
    ...sithMesRoutersMst,
    ...sithMesRoutersMstManural,
    ...sithMesRoutersAndon,
    ...sithMesRoutersPrd,
    ...sithMesRoutersPrdCustom,
    ...sithMesRoutersQuality,
    ...sithMesRoutersInventory,
    ...sithMesRoutersStool,
    ...sithMesRoutersInventoryCustom,
    ...sithMesRoutersRita,
    ...sithMesRoutersTpm,
    ...sithMesRoutersCustomer,
    ...sithMesRoutersAgreement,
    ...sithMesRoutersAgreementCustom,
]
